import { haversineDistanceM } from "./routeLineStyle";

// Нода рядом с самим треком (минимум по всем точкам), а не с его центром:
// показания станции переносим на маршрут, только если он мимо неё проходит.
// 2 км - дальше это уже другие высота и экспозиция.
export const nearestNodeToTrack = <T extends { latitude: number; longitude: number }>(
  nodes: T[],
  coords: number[][] | undefined,
  maxKm = 2
) => {
  if (!coords?.length) return null;
  let best: { node: T; km: number } | null = null;
  for (const node of nodes) {
    for (const p of coords) {
      const km = haversineDistanceM(p[1], p[0], node.latitude, node.longitude) / 1000;
      if (km <= maxKm && (!best || km < best.km)) best = { node, km };
    }
  }
  return best;
};
